function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useRef, useState } from 'react';

/**
 * useRepeater allows you to execute `fn`, `numberOfTimesToExecute` times with `numberOfSecondsBetweenCalls`
 * between each call
 *
 * @param function fn expects a function that returns a promise
 * @param function onNumberOfExecutionsExceeded expects a function and is a callback triggered when repeater fails
 * @param int numberOfSecondsBetweenCalls The number of seconds between two calls
 * @param int numberOfTimesToExecute the number of times to retry a function
 *
 * @return object { start, stop } Use `start()` to start repeating, `stop()` when you want to stop repeating.
 *
 */

var noop = function noop() {};
var useRepeater = function useRepeater(_ref) {
  var fn = _ref.fn,
    _ref$onNumberOfExecut = _ref.onNumberOfExecutionsExceeded,
    onNumberOfExecutionsExceeded = _ref$onNumberOfExecut === void 0 ? noop : _ref$onNumberOfExecut,
    numberOfSecondsBetweenCalls = _ref.numberOfSecondsBetweenCalls,
    _ref$numberOfTimesToE = _ref.numberOfTimesToExecute,
    numberOfTimesToExecute = _ref$numberOfTimesToE === void 0 ? 9999999 : _ref$numberOfTimesToE;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    counter = _useState2[0],
    setCounter = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    running = _useState4[0],
    setRunning = _useState4[1];
  var repeaterTimeout = useRef(null);
  useEffect(function () {
    if (running) {
      repeaterTimeout.current = setTimeout(execute, numberOfSecondsBetweenCalls * 1000);
    }
    return function () {
      return clearTimeout(repeaterTimeout.current);
    };
  }, [counter, running]);
  var execute = function execute() {
    var possiblePromise = fn();
    if (possiblePromise instanceof Promise) {
      possiblePromise.then(updateCount, updateCount);
    } else {
      updateCount();
    }
  };
  var updateCount = function updateCount() {
    var numberOfExecutions = counter + 1;
    if (numberOfExecutions >= numberOfTimesToExecute) {
      onNumberOfExecutionsExceeded();
      stop();
    }
    setCounter(numberOfExecutions);
  };
  var start = function start() {
    setCounter(0);
    setRunning(true);
  };
  var stop = function stop() {
    return setRunning(false);
  };
  return {
    counter: counter,
    running: running,
    start: start,
    stop: stop
  };
};
export default useRepeater;